import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { EventBus } from '@/services/Event.js';

import TableData from '../table/table.vue';
import FilterBar from '../filter-bar/filter-bar.vue';
import { Pagination as LPagination } from '@/components/index';

export default {
    name: 'ClubsLayout',
    components: {
        'table-data': TableData,
        'filter-bar': FilterBar,
        LPagination

    },
    watch: {
        filter: {
            immediate: true,
            handler(newVal, oldVal) {
                if (JSON.stringify(newVal) == JSON.stringify(oldVal)) {
                    return;
                }
                if (!oldVal) {
                    this.init();
                }
                else {
                    this.load();
                }
            }
        },
        page: {
            immediate: true,
            handler(newVal) {
                if (newVal != this.filter.options.page) {
                    this.filter.options.page = newVal;
                    this.load();
                }
            }
        }
    },
    data() {
        return {
            currentLastYear: new Date().getFullYear(),
            isNeedSupportDataFlag: true,
            isProcessing: false,
            tableData: [],
            filter: {
                clubName: null,
                year: new Date().getFullYear(),
                options: { skip: 0, take: 5, perPage: 5, page: 1 }
            },
            years: [{ id: null, label: 'Any', value: null }],
            total: 0,
            page: 1,
        }
    },
    computed: {
        filterQuery() {
            return this.createQueryString(this.getFilter());
        },
        isNeedSupportData() {
            return this.isNeedSupportDataFlag || !this.years || !this.years.length || !this.years[this.years.length - 1].value;
        },
        skip() {
            return (this.filter.options.page - 1) * this.filter.options.perPage;
        },
        take() {
            return this.filter.options.perPage;
        },
        from() {
            return this.skip + 1;
        },
        to() {
            return this.skip + this.take;
        }
    },
    methods: {
        showSuccess(message) {
            if (!message) {
                message = 'Operation success!';
            }

            this.$notify({
                message: message,
                type: 'success',
                timeout: 1000
            });
        },
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    const date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        createQueryString(data, parentKey) {
            var parent = parentKey ? parentKey + "." : '';
            var result = parentKey ? "" : '?';

            Object.keys(data).map(key => {
                let value = data[key];

                if (value == null || value == undefined) {
                    return;
                }
                else if (typeof value === 'object') {
                    result += this.createQueryString(value, parent + key);
                }
                else {
                    result += `${parent}${key}=${encodeURIComponent(`${value}`)}&`;
                }
            });

            if (!parentKey) {
                result = result.substring(0, result.length - 1);
            }
            return result;
        },
        init() {
            this.load();
        },
        getFilter()
        {
            let filter = { ...this.filter };
            filter.options.skip = this.skip;
            filter.options.take = this.take;
            filter.isNeedSupportData = this.isNeedSupportData;

            if (!filter.clubName) {
                filter.clubName = '';
            }
            return filter;
        },
        to_top() {
            setTimeout(() => {
                window.scrollTo(105, 105);
            }, 1000)
        },
        load() {
            const self = this;
            self.isProcessing = true;
            request.getClubsList(self.filterQuery)
                .then(res => {
                    self.isProcessing = false;
                    if (res && res.body && res.body.isSuccess) {
                        self.tableData = res.body.all;
                        self.total = res.body.total;

                        if (self.isNeedSupportData) {
                            self.currentLastYear = res.body.currentYear;
                            self.initYearsFilter(res.body.isAwailableNextYearClubAffilation);
                            self.isNeedSupportDataFlag = false;
                        }
                    }
                    else {
                        self.$showError(res && res.body && res.body.message ? res.body.message : null);
                    }
                    self.to_top();
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError(5000);
                    });
        },
        initYearsFilter(isNextYear) {
            var self = this;
            for (var year = self.currentLastYear + (isNextYear ? 1 : 0); year >= 2015; year--) {
                self.years.push({ id: year, label: '' + year, value: year });
            }
        }
    },
    created() {
        var self = this;
        EventBus.$off('club-list-reload');
        EventBus.$on('club-list-reload', () => self.load());
    },
    destroyed() {
        EventBus.$off('club-list-reload');
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/club/clubs-list/layout/layout.js